export default "__VITE_ASSET__i$RFdWbn__"